import { render, staticRenderFns } from "./StaffSen.vue?vue&type=template&id=1df17e38&scoped=true&"
import script from "./StaffSen.vue?vue&type=script&lang=js&"
export * from "./StaffSen.vue?vue&type=script&lang=js&"
import style0 from "./StaffSen.vue?vue&type=style&index=0&id=1df17e38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df17e38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/98-prod-frontend-deploy-tke/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1df17e38')) {
      api.createRecord('1df17e38', component.options)
    } else {
      api.reload('1df17e38', component.options)
    }
    module.hot.accept("./StaffSen.vue?vue&type=template&id=1df17e38&scoped=true&", function () {
      api.rerender('1df17e38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chat/components/StaffSen.vue"
export default component.exports